import { httpGatewayService } from "@/modules/common/services";

const route = 'client/signatures/signatures';

const getSignature = async (entityType, entityUid) => {
  const res = await httpGatewayService.get(`${route}/${entityType}/${entityUid}`);
  if (!res.success) return;
  return res.data.signature;
};

export default {
  getSignature
}
